import Vue from 'vue'
import {
  fetchItems
} from '../../api'

const state = {
  byProject: {},
  total: {}
}

const getters = {}

const actions = {
  getItems ({ commit }, { projectId }) {
    fetchItems(projectId).then(data => {
      commit('setItems', { projectId, items: data.entries })
      commit('setTotalItems', { projectId, total: data.total })
    })
  },
}

const mutations = {

  setItems (state, { projectId, items }) {
    Vue.set(state.byProject, projectId, items || [])
  },

  setTotalItems (state, { projectId, total }) {
    Vue.set(state.total, projectId, total)
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
